// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'
import iView from 'view-design'
import i18n from '@/locale'
import menu from './libs/menu'
import common from './libs/util.js'
import config from './libs/config.js'
import numberChinese from '@/libs/numberChinese.js'
import { get, post, postFormData, patch, del, put, exportGet, exportPost, exportFollow, specialExportGet, getTencentFile } from './libs/axios'
import Viewer from 'v-viewer'
import VueClipboard from 'vue-clipboard2'
import * as echarts from 'echarts'
import * as WPS from './../static/wps/web-office-sdk-v1.1.5.es.js'
import '@/icons'
import 'view-design/dist/styles/iview.css'
import 'viewerjs/dist/viewer.css'
import '../static/fontIcon/style.css'
import './assets/myTheme.less'
import './assets/common.scss'

import permission from '@/directive/permission/index.js'
import '@/directive/qcc'
Vue.directive('permission', permission)
import focus from '@/directive/focus/index'
Vue.directive('focus', focus)
import './permission'
import my_UI from '@/components/common/index.js'

import { typeFormat } from '@/libs/filter'
import print from '@/libs/print'
// import { isNewVersion } from '@/libs/check-project-version'
// setInterval(() => {
//   isNewVersion()
// }, 10000)
Vue.use(print)
// 商标分类格式化工具
Vue.filter('typeFormat', typeFormat)

Vue.use(my_UI)

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(Viewer, {
  // https://www.cnblogs.com/iuniko/p/16422484.html（2022-06-29 vue组件 v-viewer 在同时打开了 iview 的 modal 时，modal的层级会覆盖 v-viewer）
  defaultOptions: {
    zIndex: 9999 // 这里设置层级高度
  }
})
Vue.config.productionTip = false // 设置为 false 以阻止 vue 在启动时生成生产提示。
Vue.use(VueClipboard)

// 大数据表格
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VXETable)

Vue.prototype.$Message.config({
  duration: 3
})
Vue.prototype.wps = WPS
Vue.prototype.common = common
Vue.prototype.config = config
Vue.prototype.numberChinese = numberChinese
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$patch = patch
Vue.prototype.$del = del
Vue.prototype.$put = put
Vue.prototype.$exportGet = exportGet
Vue.prototype.$specialExportGet = specialExportGet
Vue.prototype.$exportPost = exportPost
Vue.prototype.$postFormData = postFormData
Vue.prototype.$exportFollow = exportFollow
Vue.prototype.$getTencentFile = getTencentFile
Vue.prototype.menu = menu.menuJson
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$echarts = echarts

// 防多次点击，重复提交
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, 3000)
      }
    })
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js